<template lang="html">
    <div class="page" id="proCategories">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/offers.png" />
        </header>

        <div class="scroller2 green">
            <header>
                <h2>Edit categories</h2>
                <ul class="links">
                    <li>
                        <router-link class="cancel" :to="{ name: 'proOffers' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <empty-placeholder class="mt10 mb10" v-if="categories.length == 0">
                TIP: Add and manage your offer categories here. To get started tap the button below.
            </empty-placeholder>

            <ul class="categories" v-if="categories.length > 0">
                <category-item
                    v-for="category in categories"
                    :key="category.id"
                    :category="category"
                />
            </ul>

            <form class="form3" v-if="formOpen" @submit.prevent="saveCategory">
                <div class="formGroup">
                    <input
                        type="text"
                        maxlength="255"
                        v-model="form.name"
                        placeholder="Your category title here"
                    />

                    <has-error class="info error" :form="form" field="name"></has-error>
                </div>
                <div class="formGroup">
                    <button :disabled="form.busy" class="button" type="submit" name="button">
                        {{ form.busy ? "Please wait..." : "Save" }}
                    </button>
                </div>
            </form>
            <button
                v-if="!formOpen"
                class="button left dark"
                type="button"
                @click.prevent="formOpen = true"
            >
                Add category
                <plus-icon class="icon" />
            </button>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import CategoryItem from "@/components/Pro/Offers/category-item";
import { Form, HasError } from "vform";
import { PlusIcon, XIcon } from "vue-feather-icons";
export default {
    name: "Categories",
    components: { EmptyPlaceholder, FadeImage, PlusIcon, HasError, CategoryItem, XIcon },
    data() {
        return {
            formOpen: false,
            form: new Form({
                name: "",
            }),
        };
    },
    created() {
        this.$store.dispatch("getCategories");
    },
    computed: {
        categories() {
            return this.$store.state.categories;
        },
    },
    methods: {
        saveCategory() {
            this.form.post("/category").then((category) => {
                this.$store.dispatch("addCategory", category.data);
                this.formOpen = false;
                this.form.name = "";
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#proCategories {
    .categories {
        margin-bottom: 30px;
    }
    h2 {
        margin-bottom: 30px;
    }
}
</style>
